/**
 * @todo: Candidate for including to a shared library.
 *
 * @todo: Maybe replace with `redux-thunk`?
 * @link https://www.npmjs.com/package/redux-thunk
 * @link https://redux.js.org/usage/writing-logic-thunks#using-createasyncthunk
 * @link https://redux.js.org/tutorials/fundamentals/part-8-modern-redux#writing-thunks
 */
import { createAction } from '@reduxjs/toolkit';
/**
 * Creates an async action creator.
 */
const createAsyncAction = (type) => ({
    request: createAction(`${type}_REQUEST`),
    success: createAction(`${type}_SUCCESS`),
    failure: createAction(`${type}_FAILURE`),
});
export default createAsyncAction;
